// Lib
import React, { useEffect } from 'react';
import Typography from '@mui/material/Typography';
import { useDispatch, useSelector } from 'react-redux';

// Components
import FooterButtons from '../../Modal/FooterButtons';

// Hooks
import useModal from '../../../hooks/useModal';
import use2Modal from '../../../hooks/use2Modal';

// Styles
import { useStyles } from './ConfirmCardStyles';
import { ClearApiError } from '../../../actions/apiError';

const ConfirmCard = ({
  modal2Mode,
  onConfirm,
  title = 'Do You Want To Delete?',
  message = 'Deleting Will Remove This Address From The Address Book.',
  isAcceptBtnMain = true,
  loadingBtn = false,
}) => {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const { onClose } = useModal();
  const { onClose: on2Close } = use2Modal();
  const { apiError } = useSelector((state) => ({
    apiError:
      state.apiError['delete-recurring-address'] ||
      state.apiError['cancel-recurring-order'] ||
      state.apiError['deleteKit'] ||
      state.apiError['deleteAllKits'],
  }));

  useEffect(() => {
    return () => dispatch(ClearApiError());
  }, [dispatch]);

  return (
    <>
      <Typography variant="h2">{title}</Typography>
      <div className={classes.message}>{message}</div>
      {apiError && <div className={classes.accent}>{apiError}</div>}
      <FooterButtons
        isLoading={loadingBtn}
        className={classes.buttons}
        isAcceptBtnMain={isAcceptBtnMain}
        onAccept={onConfirm}
        onReject={modal2Mode ? on2Close : onClose}
        acceptTitle="Yes"
        rejectTitle="No"
      />
    </>
  );
};

export default ConfirmCard;
